import React from 'react'
import PropTypes from 'prop-types'
import { Grid } from '@chatterbug/aaron'

import ActivityCard from '../ActivityCard/ActivityCard'

const NextActivitiesContainer = ({
  activityCardList,
  l2Code,
  isQueueEmpty,
}) => {
  return (
    <Grid
      gridGap="2x"
      width="100%"
      gridTemplateColumns={{
        _: '1fr',
        tablet: 'repeat(3, 1fr)',
      }}
    >
      {activityCardList.map((activity, i) => {
        return (
          <ActivityCard
            key={i}
            l2Code={l2Code}
            recommended
            {...activity}
            isQueueEmpty={isQueueEmpty}
          />
        )
      })}
    </Grid>
  )
}

NextActivitiesContainer.propTypes = {
  activityCardList: PropTypes.arrayOf(
    PropTypes.shape({
      coverImageUrl: PropTypes.string,
      format: PropTypes.string,
      heading: PropTypes.string.isRequired,
      unit: PropTypes.shape({
        name: PropTypes.string,
      }),
      identifier: PropTypes.string,
    })
  ),
  l2Code: PropTypes.string.isRequired,
  isQueueEmpty: PropTypes.bool,
}

export default NextActivitiesContainer
